<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>

    import {EventBus} from "./util/event-bus";
    import firebase from 'firebase/app';

    export default {
        components: {

        },

        data() {
            return {
                isLoading: false,

            }
        },

    }

</script>

<style lang="scss">


    body {
        margin: 0
    }

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
        min-height: 100%;
        background: white url("/images/background_menu.jpg") no-repeat fixed center ;
        background-size: cover;
    }

    .is-vertical-center {
        display: flex;
        align-items: center;
    }

</style>
